import React from 'react';
import '../modern.css';
import PageLayout from './PageLayout';
import SectionHeading from './SectionHeading';
import ContentCard from './ContentCard';
import useReveal from '../useReveal';
import { pageContent } from './pageContent';

function Consultancy() {
  useReveal();
  const cards = pageContent.consultancy.cards;
  return (
    <PageLayout
      pageKey="consultancy"
      heroVisual={
        <div className="hero-card">
          <img src="images/tom.png" alt="Tom Foster, Founder of Databuilder" className="hero-portrait" />
          <div className="hero-card__body">
            <h3>HM Government Recognised Expertise</h3>
            <p>Industry Expert and Local Government Sector Expert in AI, data and digital transformation.</p>
          </div>
        </div>
      }
    >

      <section className="section" id="services">
        <SectionHeading {...pageContent.consultancy.sections.services} />
        <div className="service-grid">
          {cards.services.map((card) => (
            <ContentCard
              key={card.title}
              className="service-card"
              title={card.title}
              description={card.description}
              items={card.items}
            />
          ))}
        </div>
      </section>

      <section className="section section--alt">
        <SectionHeading {...pageContent.consultancy.sections.sectors} />
        <div className="pitch-grid">
          {cards.sectors.map((card) => (
            <ContentCard
              key={card.title}
              className="pitch-card"
              icon={card.icon}
              title={card.title}
              description={card.description}
            />
          ))}
        </div>
      </section>

      <section className="section">
        <SectionHeading {...pageContent.consultancy.sections.work} />
        <div className="methodology-steps">
          {cards.work.map((card, index) => (
            <ContentCard
              key={card.title}
              className="step"
              stepNumber={index + 1}
              title={card.title}
              description={card.description}
            />
          ))}
        </div>
      </section>

      <section className="section section--alt" id="engagement">
        <SectionHeading {...pageContent.consultancy.sections.engagement} />
        <div className="engagement-grid">
          {cards.engagement.map((card) => (
            <ContentCard
              key={card.title}
              className={`engagement-card ${card.featuredBadge ? 'featured' : ''}`.trim()}
              title={card.title}
              price={card.price}
              featuredBadge={card.featuredBadge}
              description={card.description}
              items={card.items}
              ctaLabel={card.ctaLabel}
              ctaHref={card.ctaHref}
              ctaClassName={card.ctaClassName}
            />
          ))}
        </div>
      </section>

    </PageLayout>
  );
}

export default Consultancy;
